import { FeatureManagementComponent } from './modules/feature/feature-management/feature-management.component';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginComponent} from './login/login.component';
import {NotAuthorizedComponent} from './not-authorized';

const routes: Routes = [
  {path: '', redirectTo: 'login', pathMatch: 'full'},
  {path: 'login', component: LoginComponent},
  {path: 'campaign', loadChildren: () => import('./modules/campaign/campaign.module').then(m => m.CampaignModule)},
  {path: 'fordpass-control', loadChildren: () => import('./modules/fordpass-control/fordpass-control.module').then(m => m.FordpassControlModule)},
  {path: 'feature', loadChildren: () => import('./modules/feature/feature.module').then(m => m.FeatureModule)},
  {path: 'country', loadChildren: () => import('./modules/country-register/country-register.module').then(m => m.CountryRegisterModule)},
  {path: 'not-authorized', component: NotAuthorizedComponent},
  {path: '**', component: LoginComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: false, scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {
}
